import * as React from 'react';
import mathLogo from '../../../../../assets/images/math.png';

const MathLogo = () => (
    <img src={mathLogo} alt="Core Logo" width="16" height="16" />
);

export default MathLogo;
